
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/things-to-do",
      function () {
        return require("private-next-pages/things-to-do.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/things-to-do"])
      });
    }
  